import { Price, Text, LegacyText } from "flicket-ui";

export interface IPriceWithFee {
  price: number;
  showFees: boolean;
  isSoldOut?: boolean;
  fee?: number;
}

const PriceWithFee = ({
  price,
  showFees = false,
  isSoldOut = false,
  fee = 0,
}: IPriceWithFee) => {
  if (isSoldOut) return <>Sold out</>;

  if (!price && !showFees) return <>Free</>;

  if (!price && fee <= 0) return <>Free</>;

  if (!showFees || fee <= 0) {
    return <Price price={price} />;
  }

  return (
    <>
      <Price price={price + fee} />{" "}
      <Text as="span" variant="small">
        (
        {price > 0 && (
          <>
            <Price price={price} /> +{" "}
          </>
        )}
        <Price price={fee} /> fees)
      </Text>
    </>
  );
};

export default PriceWithFee;
